/** Remaining ms on the active interval clock (prep shows full duration; overtime reads as 0). */
export function getBoggleIntervalRemainingMs({
  intervalDeadlineMs,
  intervalDurationMs,
  intervalPlayBeginsAtMs,
  isInOvertime,
  timeMs,
}: {
  intervalDeadlineMs: null | number
  intervalDurationMs: number
  intervalPlayBeginsAtMs: null | number
  isInOvertime: boolean
  timeMs: number
}) {
  if (isInOvertime) {
    return 0
  }

  if (intervalPlayBeginsAtMs !== null && timeMs < intervalPlayBeginsAtMs) {
    return intervalDurationMs
  }

  return intervalDeadlineMs === null ? 0 : Math.max(0, intervalDeadlineMs - timeMs)
}
